export const getRequestStatusClassName = (status) => {
    const map = {
        NEW: 'alert-color',
        PROCESSING: 'pending-color',
        OPEN: 'pending-color',
        IN_PROGRESS: 'pending-color',
        RESOLVED: 'accepted-color',
        CLOSED: 'accepted-color',
        CANCELED: 'cancelled-color',
    };

    return map[status] || '';
};

export const getBookingStatusClassName = (status) => {
    const map = {
        ACCEPTED: 'accepted-color',
        PENDING: 'pending-color',
        INVOICED: 'invoiced-color',
        CANCELED: 'cancelled-color',
        CANCELLED: 'cancelled-color',
        COMPLETED: 'accepted-color',
    };

    return map[status] || '';
};

export const buildDashboardStats = (overview) => ({
    bookings: overview?.bookings || {
        total: 0,
        increase: 0,
    },
    income: overview?.income || {
        total: 0,
        increase: 0,
    },
    cancels: overview?.cancels || {
        total: 0,
        increase: 0,
        cancelPercent: 0,
    },
    reviews: overview?.reviews || {
        total: 0,
        complainPercent: 0,
    },
    inProgressBookings: overview?.inProgressBookings || {
        total: 0,
        latestRentalDate: null,
    },
    pendingBookings: overview?.pendingBookings || {
        total: 0,
        closestExpiryDate: null,
    },
    inProgressRequests: overview?.inProgressRequests || {
        total: 0,
        newReply: 0,
    },
});

export const normalizeSalesChartData = (chartData = []) => {
    return chartData.map((item) => ({
        ...item,
        TotalPreviousYear:
            (item.SalesBookingsPreviousYear || 0) + (item.SalesGroupsPreviousYear || 0),
        TotalCurrentYear:
            (item.SalesBookingsCurrentYear || 0) + (item.SalesGroupsCurrentYear || 0),
    }));
};

export const normalizeWorldMapData = (rawData = []) => {
    const countryNameMap = {
        'United States': 'United States of America',
    };

    return rawData.map((item) => ({
        ...item,
        name: countryNameMap[item.name] || item.name,
    }));
};